import { authRoles } from 'app/auth';
import { FuseLoadable } from '@fuse';

const EmbeddedProcessorCheckoutReportConfig = {
    auth: [...authRoles.processor],
    routes: [{ exact: true, path: '/invoicing/processor-checkout-report', component: FuseLoadable({ loader: () => import('./ViewEmbeddedProcessorCheckoutReportApp') }) }],
};

export default EmbeddedProcessorCheckoutReportConfig;
